// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Qz0RS","footer":"ModalError_footer__1DN5D"};